export const text = {
  pageTitle: "Manage CMS",
  serialNo: "S.No.",
  pageName: "Page Name",
  action: "Actions",
  edit: "Edit",
};
